import { TimeSpans } from '@/__generated__/types';

export type DashboardPeriod =
  | TimeSpans.Last_7Days
  | TimeSpans.Last_30Days
  | TimeSpans.Last_366Days;

export const AVAILABLE_TIMESPANS: readonly DashboardPeriod[] = [
  TimeSpans.Last_7Days,
  TimeSpans.Last_30Days,
  TimeSpans.Last_366Days,
];

export const DEFAULT_TIMESPAN: DashboardPeriod = TimeSpans.Last_30Days;

// Short labels for the toggle buttons
export const TIMESPAN_LABEL: Record<DashboardPeriod, string> = {
  [TimeSpans.Last_7Days]: '7D',
  [TimeSpans.Last_30Days]: '30D',
  [TimeSpans.Last_366Days]: '12M',
};

export const isDashboardPeriod = (
  value: string | null,
): value is DashboardPeriod =>
  AVAILABLE_TIMESPANS.includes(value as DashboardPeriod);
